import React, { useState } from 'react';

const useContextMenu = () => {
	const [showContextMenu, setShowContextMenu] = useState(false); // hook to show/hide menu on phone
	const [anchorEl, setAnchorEl] = useState(null); // anchor for phone menu

	const openContextMenu = (e) => {
		e.preventDefault();
		let clientX, clientY;
		if (e.type === 'click' || e.type === 'contextmenu') {
			clientX = e.clientX;
			clientY = e.clientY;
		} else if (e.type === 'touchend' || e.type === 'touchstart') {
			clientX = e.changedTouches[0].clientX;
			clientY = e.changedTouches[0].clientY;
		}

		setAnchorEl({
			left: clientX,
			top: clientY,
		});
		setShowContextMenu(true);
	};

	const closeContextMenu = () => {
		setShowContextMenu(false);
		setAnchorEl(null);
	};
	return {
		openContextMenu,
		closeContextMenu,
		showContextMenu,
		setShowContextMenu,
		anchorEl,
		setAnchorEl,
	};
};

export default useContextMenu;
